/* RESPONSIBLE TEAM: team-proactive-support */
import NodeConfiguration, { NODE_CATEGORIES } from 'embercom/objects/series/node-configuration';
import WaitInserterConfiguration from 'embercom/objects/series/node/wait-inserter-configuration';

export default class WaitNodeConfiguration extends NodeConfiguration {
  inserterConfiguration = new WaitInserterConfiguration();
  category = NODE_CATEGORIES.action;
}
